import Vue from 'vue'
import app from './app'
export default {
  namespaced: true,
  state: {
    finnaceUpcomingList: [],
    finnaceUpcomingListTotal: 0,
    finnaceUpcomingCurrentPage: 1,
    finnaceUpcomingPageSize: 10,
    searchPeople: '',
    searchInfo: '',
    searchDate1: '',
    searchDate2: '',
    fromMyFlow: false,
    searchStagecode: '',
  },
  mutations: {
    // 待办财务
    async get_finnace_coming_list_mutation(state, data) {
      let param = new URLSearchParams()
      param.append('member_id', localStorage.getItem('btlh_process_member_id') || '')
      param.append('token', localStorage.getItem('btlh_process_token') || '')
      if (app.state.deviceInfo) {
        param.append('device', app.state.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('cache_department_id', localStorage.getItem('bthl_process_cache_department_id_store') || '')
      param.append('company_id', localStorage.getItem('bthl_process_LoginCompanyId') || '')


      param.append('search', state.searchInfo)
      param.append('start_time', state.searchDate1)
      param.append('end_time', state.searchDate2)

      param.append('search_member_id', state.searchPeople)
      param.append('stage_code', state.searchStagecode)
      param.append('p', state.finnaceUpcomingCurrentPage)
      param.append('p_count', state.finnaceUpcomingPageSize)
      const { data: res } = await Vue.prototype.$axios({
        method: 'post',
        url: '/api/Management/finance_list',
        data: param,
      })
      if (res.code != 200) return this.$message.error(res.datas.msg)
      const list = res.datas.listInfo
      list.forEach((item) => {
        item.project_listShow = ''
        item.project_list.forEach((items) => {
          item.project_listShow += (items + '  ')
        })
      })
      state.finnaceUpcomingList = list
      console.log('state.finnaceUpcomingList', state.finnaceUpcomingList)
      state.finnaceUpcomingListTotal = parseInt(res.datas.count)
    },
    // *已办财务
    async get_finnace_wait_list(state, data) {
      let param = new URLSearchParams()
      param.append('member_id', localStorage.getItem('btlh_process_member_id') || '')
      param.append('token', localStorage.getItem('btlh_process_token') || '')
      if (app.state.deviceInfo) {
        param.append('device', app.state.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('cache_department_id', localStorage.getItem('bthl_process_cache_department_id_store') || '')
      param.append('company_id', localStorage.getItem('bthl_process_LoginCompanyId') || '')


      param.append('search', state.searchInfo)
      param.append('start_time', state.searchDate1)
      param.append('end_time', state.searchDate2)

      param.append('search_member_id', state.searchPeople)
      param.append('stage_code', state.searchStagecode)
      param.append('p', state.finnaceUpcomingCurrentPage)
      param.append('p_count', state.finnaceUpcomingPageSize)
      const { data: res } = await Vue.prototype.$axios({
        method: 'post',
        url: '/api/Management/arfinance_list',
        data: param,
      })
      if (res.code != 200) return this.$message.error(res.datas.msg)
      const list = res.datas.listInfo
      list.forEach((item) => {
        item.project_listShow = ''
        item.project_list.forEach((items) => {
          item.project_listShow += (items + '  ')
        })
      })
      state.finnaceUpcomingList = list
      console.log('state.finnaceUpcomingList', state.finnaceUpcomingList)
      state.finnaceUpcomingListTotal = parseInt(res.datas.count)
    },
    setFinnaceUpcomingCurrentPage(state, data) {
      state.finnaceUpcomingCurrentPage = data
    },
    setFinnaceUpcomingPageSize(state, data) {
      state.finnaceUpcomingPageSize = data
    },
    setFinnaceUpcomingList(state, data) {
      state.finnaceUpcomingList = data
    },
    setFinnaceUpcomingListTotal(state, data) {
      state.finnaceUpcomingListTotal = data
    },
    setSearchInfo(state, data) {
      state.searchInfo = data
    },
    setSearchPeople(state, data) {
      state.searchPeople = data
    },
    setSearchStagecode(state, data) {
      state.searchStagecode = data
    },
    setSearchDate1(state, data) {
      state.searchDate1 = data
    },
    setSearchDate2(state, data) {
      state.searchDate2 = data
    }
  },
  actions: {

  },
  getters: {

  },
}
